import { Component } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { Icons } from '../../shared/helpers/icons';

@Component({
  selector: 'app-no-access',
  standalone: true,
  imports: [LucideAngularModule],
  template: `
    <div class="flex h-screen w-full items-center justify-center bg-main-background p-6">
      <div class="flex w-full max-w-xl flex-col items-center gap-3 rounded-md bg-white p-8 text-center shadow-custom-2">
        <lucide-icon [img]="icons.ShieldAlert" class="text-gray-300" [size]="48"></lucide-icon>
        <h1 class="oswald-font text-3xl uppercase text-nside-orange-400">Access Restricted</h1>
        <p class="text-slate-700">You need Site Admin permissions to manage users for this building.</p>
      </div>
    </div>
  `
})
export class NoAccessComponent {
  icons = Icons;
}
